@if (operation) {
    <tec-collapse
        [icon]="'icon-user'"
        [title]="'PROCESSES.DETAIL.POL' | translate"
        [tags]="[
            {
                label: ('MASTER.STATUS.' + operation.state | translate),
                status: masterService.getTagStatus(operation.state)
            }
        ]"
        [expanded]="expanded"
        (clickEvent)="toggleCollapse.emit($event)"
    >
        <app-developer-curl-button
            ngProjectAs="tec-button-icon"
            [path]="operationCurlPath"
            titleKey="PROCESSES.CURL_MODAL.TITLE_OPERATION"
        />
        @if (loading && !contentReady) {
            <!-- SLOT_LOADING_POL -->
            <tec-tile [type]="'loading'" [title]="'LOADING.PROCESS_DETAIL' | translate" />
        } @else if (operation.state !== OPERATION_STATUS.INIT && operation.state !== OPERATION_STATUS.NOT_STARTED) {
            <tec-tile [title]="'PROCESSES.DETAIL.DETAILS' | translate">
                @if (operation.mode === 'auto') {
                    @for (tried of operation.data; track $index) {
                        @if (isAutoPolTry(tried)) {
                            <div class="item-group">
                                <tec-info-group>
                                    <span style="color: #96939E">{{ ('GENERAL.TRIED' | translate: {num: $index + 1}).toUpperCase() }}</span>
                                    <tec-tag
                                        [label]="'MASTER.POL_STATUS.' + tried.general.status?.toUpperCase() | translate"
                                        [status]="masterService.getTagStatusPol(tried.general.status)"
                                    ></tec-tag>
                                </tec-info-group>
                                <div class="item-group">
                                    @for (lifeTest of tried.lifeTest; track $index) {
                                        <tec-item
                                            [title]="('MASTER.POL_TESTS.' + lifeTest.lifeTestId?.toUpperCase() | translate) + (lifeTest.scoring?.totalTries > 1 ? ' (' + ('GENERAL.TRIED_AUX' | translate: {num: lifeTest.scoring?.totalTries}) + ')': '')"
                                            [tagIcon]="{
                                                icon: masterService.getTagStatusPol(lifeTest.status) === 'success' ? 'icon-check' : 'icon-alert',
                                                status: masterService.getTagStatusPol(lifeTest.status),
                                                size: 'sm'
                                            }"
                                            [detailAction]="lifeTest.finishAt | safeDate: 'dd/MM/yyyy - HH:mm:ss'">
                                            @if (lifeTest.scoring?.totalTime || lifeTest.scoring?.result) {
                                                <tec-list-detail>
                                                    @if (lifeTest.scoring?.totalTime) {
                                                        <span>{{ lifeTest.scoring?.totalTime ? (lifeTest.scoring?.totalTime | number:'1.0-0') + ' s' : '' }}</span>
                                                    }
                                                    @if (lifeTest.scoring?.result) {
                                                        <span>{{ lifeTest.scoring?.result ? (lifeTest.scoring?.result | number:'1.0-1') + ' ptos' : '' }}</span>
                                                    }
                                                </tec-list-detail>
                                            } @else {
                                                <span>{{ polFailReasonService.getPolTestFailReasonFromFullScoring(lifeTest) | translate }}</span>
                                            }
                                        </tec-item>
                                    }
                                    @if (tried.general?.scoring) {
                                        <tec-item
                                            [title]="'PROCESSES.DETAIL.RESULT' | translate"
                                            [tagIcon]="{
                                                icon: processHelper.isPolGeneralResultOk(tried.general) ? 'icon-check' : 'icon-alert',
                                                status: processHelper.isPolGeneralResultOk(tried.general) ? 'success' : 'error',
                                                size: 'sm'
                                            }"
                                        >
                                            @if (tried.general?.scoring?.totalTime || tried.general?.scoring?.result) {
                                                <tec-list-detail>
                                                    <span>{{ tried.general?.scoring?.result ? (tried.general?.scoring?.result | number:'1.0-1') + ' ptos' : '' }}</span>
                                                    <span>
                                                        {{ processHelper.isPolGeneralResultOk(tried.general) ? ('PROCESSES.DETAIL.POL_OK' | translate) : ('PROCESSES.DETAIL.POL_KO' | translate) }}
                                                        <tec-tooltip [label]="'PROCESSES.DETAIL.POL_TRIED_EXPLICATION' | translate">
                                                            <tec-icon style="margin-left: 3px;" name="icon-info"></tec-icon>
                                                        </tec-tooltip>
                                                    </span>
                                                </tec-list-detail>
                                            }
                                        </tec-item>
                                    }
                                </div>
                            </div>
                        }
                    }
                    @if (!operation.data) {
                        <tec-empty-state
                            [title]="'GENERAL.NO_DATA' | translate"
                            [size]="'default'"
                            [type]="'empty'"
                        ></tec-empty-state>
                    }
                } @else {
                    <span>{{ (operation.state === OPERATION_STATUS.OK ? 'PROCESSES.DETAIL.POL_MANUAL_LIVENESS_OK' : 'PROCESSES.DETAIL.POL_MANUAL_LIVENESS_KO') | translate }}</span>
                }
            </tec-tile>

            <tec-tile [title]="'PROCESSES.DETAIL.OPERATION' | translate">
                <div class="grid grid-i3">
                    <tec-info-group [label]="'PROCESSES.DETAIL.ID_OPERATION' | translate">
                        <tec-copy-text
                            [label]="processHelper.truncateUUID(operation.uuid)"
                            [labelToCopy]="operation.uuid"
                        ></tec-copy-text>
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.NUM_TRIED' | translate">
                        <tec-tag [label]="operationsHelper.getPolTriesCountLabel(operation)"></tec-tag>
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.CAPTURE_METHOD' | translate">
                        <tec-tag>{{ `WORKFLOWS.FORM.OPERATIONS.${operation.mode === 'auto'? 'POL_MODE_ACTIVE' : 'POL_MODE_STATIC'}` | translate  }}</tec-tag>
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.TYPE' | translate">
                        <span>{{ operation.type ? ('MASTER.POL_TYPE.' + operation.type?.toUpperCase() | translate) : ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                    </tec-info-group>
                    <!-- TODO GESTIONAR CUANDO SEA MANUAL -->
                    @if (validation === 'auto') {
                        <tec-info-group [label]="'PROCESSES.DETAIL.VERIFICATION' | translate">
                            <tec-tag [label]="`PROCESSES.DETAIL.AUTOMATIC` | translate"></tec-tag>
                        </tec-info-group>
                    }
                </div>
                <tec-divider></tec-divider>
                <div class="grid grid-i3">
                    <tec-info-group [label]="'PROCESSES.DETAIL.START_DATE' | translate">
                        <tec-icon name="icon-calendar"></tec-icon>
                        <span>{{( operation.start_at | safeDate: 'dd/MM/yyyy - HH:mm') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.END_DATE' | translate">
                        <tec-icon name="icon-calendar"></tec-icon>
                        <span>{{ (operation.end_at | safeDate: 'dd/MM/yyyy - HH:mm') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.DURATION' | translate">
                        <tec-icon name="icon-clock" size="xs" />
                        <span>{{ formatSecondsToMinutes(operation.total_time) || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                    </tec-info-group>
                </div>
                @if (operation.uuid) {
                    <tec-divider></tec-divider>
                    <tec-button
                        [label]="'PROCESSES.DETAIL.SEE_OPERATION' | translate"
                        (clickEvent)="goToOperationDetail(operation.uuid, $event)"
                    />
                }
            </tec-tile>
        } @else {
            <tec-empty-state
                [title]="'GENERAL.NO_DATA' | translate"
                [size]="'default'"
                [type]="'empty'"
            ></tec-empty-state>
        }
    </tec-collapse>
}
